<script lang="ts">
	import AppErrorBox from "./AppErrorBox.svelte";
	import GlobalPreloader from "./GlobalPreloader.svelte";
	import "./assets/css/global.css";

	$effect(() => {
		const compatibilityAlert = document.querySelector("#outdated-alert");
		compatibilityAlert?.remove();
		const preloader = document.querySelector("#preloader");
		preloader?.remove();
	});
</script>

{#snippet pending()}
	<GlobalPreloader />
{/snippet}

<svelte:boundary
	onerror={async (error) => {
		const { handleGlobalError } = await import("./utils/handleGlobalError.svelte");
		handleGlobalError(error, null);
	}}
	{pending}
>
	{@const GlobalErrorBoundary = (await import("./GlobalErrorBoundary.svelte")).default}
	{@const I18NProvider = (await import("./utils/i18n/I18nProvider.svelte")).default}
	<I18NProvider>
		<GlobalErrorBoundary {pending}>
			{@const GlobalAlertHandler = (await import("./GlobalAlertHandler.svelte")).default}
			{@const GlobalModalHandler = (await import("./GlobalModalHandler.svelte")).default}
			{@const GlobalNavigationPreloader = (await import("./GlobalNavigationPreloader.svelte")).default}
			{@const GlobalNewVersionChecker = (await import("./GlobalNewVersionChecker.svelte")).default}
			{@const GlobalUnsavedChangesHandler = (await import("./GlobalUnsavedChangesHandler.svelte")).default}
			{@const Head = (await import("./Head.svelte")).default}
			{@const InputMethodDetector = (await import("./components/utility/InputMethodDetector.svelte")).default}
			{@const PortalTargetsProvider = (await import("./components/utility/PortalTargetsProvider.svelte")).default}
			{@const Router = (await import("./Router.svelte")).default}

			<PortalTargetsProvider targets={{ popup: "#popups", modal: "#modals" }}>
				<Head />
				<InputMethodDetector />

				<GlobalUnsavedChangesHandler />
				<GlobalNewVersionChecker />
				<GlobalNavigationPreloader />
				<GlobalAlertHandler />
				<GlobalModalHandler />

				<Router />
			</PortalTargetsProvider>

			{#snippet failed(error, reset)}
				<AppErrorBox {error} {reset} />
			{/snippet}
		</GlobalErrorBoundary>
	</I18NProvider>

	{#snippet failed(error, reset)}
		<AppErrorBox
			{error}
			{reset}
			messages={{
				error: "There was an error while loading the app.",
				outdatedApp:
					"This error could have happened because you are using an outdated app version. Please try refreshing the website first.",
				outdatedBrowser:
					"This error could have happened because you are using an outdated browser version. Please try updating your browser first.",
				restartApp: "Restart app",
			}}
		/>
	{/snippet}
</svelte:boundary>
